import { isNotAValue } from "web/services/helpers"
import { Icon } from "web/components"

export default function ContactSuggestion({
  testId,
  suggestion,
  inputValue,
  isQuickAdd,
  onChooseSuggestion,
}) {
  const avatar = suggestion.avatar
  const name = suggestionWithBoldedMatch(suggestion.label, inputValue)
  const email = suggestionWithBoldedMatch(suggestion.email_address, inputValue)
  const company = suggestionWithBoldedMatch(suggestion.company_name, inputValue)

  return (
    <div
      id={testId} // Should be replace by a selectable element in Capybara
      data-testid={testId}
      onMouseDown={(e) => e.preventDefault()}
      onClick={(e) => {
        e.stopPropagation()
        onChooseSuggestion(suggestion)
      }}
      className="flex gap-x-1.5"
    >
      {suggestion.label === "-" && "-"}
      {isQuickAdd && (
        <div className="flex items-center">
          <div className="flex w-14 justify-center">
            <Icon name="user-circle" className="h-12 w-12 opacity-25" />
          </div>
          <div>{name}</div>
        </div>
      )}
      {suggestion.label !== "-" && !isQuickAdd && (
        <>
          {
            <div>
              <div className="flex">
                <div className="flex w-14 flex-col flex-wrap">
                  {avatar ? (
                    <span className={"ml-1 mt-4"}>
                      <img
                        className="inline-block h-10 w-10 overflow-hidden rounded-full bg-gray-100"
                        src={avatar}
                        alt="Avatar"
                      />
                    </span>
                  ) : (
                    <Icon
                      name="user-circle"
                      className="mt-3 h-12 w-12 opacity-25"
                    />
                  )}
                </div>
                <div>
                  <div className="mt-1.5">{name}</div>
                  <div>{email ? <>{email}</> : ""}</div>
                  <div>{company}</div>
                </div>
              </div>
            </div>
          }
        </>
      )}
    </div>
  )
}

function suggestionWithBoldedMatch(label, inputValue) {
  if (isNotAValue(label)) return null
  const words = inputValue.toLowerCase().split(/\s+/)

  let lastIndex = 0
  const suggestion = []

  words.forEach((word) => {
    const wordIndex = label.toLowerCase().indexOf(word, lastIndex)

    if (wordIndex !== -1) {
      suggestion.push(label.substring(lastIndex, wordIndex))
      suggestion.push(<strong>{label.substr(wordIndex, word.length)}</strong>)

      lastIndex = wordIndex + word.length
    }
  })

  suggestion.push(label.substr(lastIndex))

  return <span>{suggestion}</span>
}
